import { createSlice } from '@reduxjs/toolkit';

export const DEFAULT_DATA = {
    setpNumTitle: '',
    setpTitle: '',
    setpContent: '',
    skipBtnText: '',
    skipBtnCallback: null,
    nextBtnText: '',
    nextBtnCallback: null,

    position: {},
    arrowDirection: 'left',
};

export const FJSliceGuideModals = createSlice({
    name: 'sliceGuideModals',
    initialState: {
        isShow: false,
        data: DEFAULT_DATA,
    },
    reducers: {
        setSliceGuideModalsInfo: (state, action) => {
            state.isShow = action.payload;
        },

        setSliceGuideModalsData: (state, action) => {
            state.data = action.payload;
        },
    },
});

export const { setSliceGuideModalsInfo, setSliceGuideModalsData } = FJSliceGuideModals.actions;

export default FJSliceGuideModals.reducer;
